import InquireDetailPage from './InquireDetailPage';

export const InquireDetailPageConfig = {
  routes: [
    {
      path: '/pages/inquire/detail',
      exact: true,
      component: InquireDetailPage,
    },
  ],
};
